import defaultLayout from '../../../layouts/default'

export default {
  path: 'crm',
  component: defaultLayout,
  children: [
    {
      path: 'callback',
      component: () => import('./callback'),
      meta: {
        activeMenu: ''
      }
    }
  ]
}
